import React from 'react';
import styled from 'styled-components';
import Text from '@bit/knotchinc.web-react-components.text';

const StyledTitle = styled.span`
  font-size: 10px;
  font-weight: bold;
  letter-spacing: 4px;

  &:hover {
    text-decoration: none;
  }
`;

export default <StyledTitle>KNOTCH <Text display="inline" color="palette.5">BLUEPRINT</Text></StyledTitle>;
